<template>
  <transition name="post">
    <article v-if="allReady" class="post">
      <header class="post__header">
        <h2 class="post__title">{{ title }}</h2>

        <h3 class="post__meta"><router-link v-for="(category,index) in categories" class="post__author"
          :to="`/blog/category/${category.slug}`" :key="category.id">{{ category.title }} <span v-show="index<(categories.length-1)">|</span></router-link>
          <span class="post__sep"></span>
          <time>{{ (published) }} {{post.subjectblogs}}</time>
        </h3>

        <blockquote class="post__subtitle" v-html="description"></blockquote>
      </header>

      <section class="post__body rte" v-html="content"></section>
      <footer class="post__footer">
        <vue-facebook-comment v-if="commentsReady" :url="url"/>
      </footer>
    </article>
  </transition>
</template>

<script>
import VueFacebookComment from './VueFacebookComment'
import {kebabify, prettyDate} from '../helpers'

export default {
  name: 'blog-post',
  resource: 'BlogPost',
  components: { VueFacebookComment },
  props: {
    post: '',
    feed: {},
    postLoadState: false
  },

  data() {
    return {
      title: '',
      author: '',
      content: '',
      published: '',
      description: '',
      categories: [],
      commentsReady: false,
      ready: false,
      url: ''
    }
  },

  computed: {
    allReady() {
      return this.ready && this.post;
    }
  },

  watch: {
    '$route' (to, from) {
      if (to !== from && to.name === 'slug') {
        this.getPost(this.post);
        this.url = window.location.href;
      }
    },
    post(to, from) {
      // if (to === from || !this.post) return;
      // this.$emit('loadFeed', 1, this.post);
    },
    feed(to, from) {
      // console.log(to);
      // console.log(from);
      // if (to === from || !this.post) return;
      // this.commentsReady = false
      // this.$getResource('post', to)
      //   .then(this.showComments)
      //   .then(() => {
      //     this.ready = true;
      //   });
      // axios.post(`https://randomuser.me/api/`)
      //   .then(response => {
      //     this.title = response.data.results[0].name.first + ' ' + response.data.results[0].name.last;
      //     this.author = response.data.results[0].gender;
      //     this.published = response.data.results[0].registered.date;
      //     this.description = response.data.results[0].registered.date;
      //     this.content = 'Kiểm tra';
      //     this.showComments();
      //   }).then(() => {
      //     this.ready = true;
      //   });
      // console.log(to);
      // console.log(from);
      // this.$emit('loadfeed', 1, this.post)
      // console.log(this.feed[0]);
      // if (typeof this.feed[0] !== 'undefined') {
      this.initPost(this.feed);
      this.$emit('setPostLoadState', false);
      // }
    }
  },

  methods: {
    kebabify,
    prettyDate,
    showComments() {
      // This is injected by prerender-spa-plugin on build time, we don't prerender disqus comments.
      if (window.__PRERENDER_INJECTED &&
          window.__PRERENDER_INJECTED.prerendered) {
        return;
      }
      setTimeout(() => {
        this.commentsReady = true
      }, 1000)
    },
    initPost(post) {
      this.showComments();
      this.title = post.title;
      this.published = prettyDate(post.created_at);
      this.description = post.description;
      this.content = post.content;
      this.categories = post.subjectblogs;
      this.ready = true;
    },
    getPost(slug) {
      if (typeof slug !== 'undefined') {
        this.$emit('getPost', slug);
      }
    }
  },
  created() {
    // this.getPost(this.post);
    this.url = window.location.href;
  },
  mounted() {
    if (!this.post) {
      this.ready = true;
      return;
    }
    this.ready = true;
    if (this.slug !== '') {
      this.getPost(this.post);
    }
    // console.log(this.post);
    // this.showComments();
    // this.$getResource('post', this.post)
    //   .then(this.showComments)
    //   .then(() => {
    //     this.ready = true;
    //   });
    // console.log(this.$props.feed);
  },
  beforeUpdate() {
    // console.log(this.feed);
  },
  updated() {
    // console.log(this.feed);
    // if (this.postLoadState) {
    //   this.getPost(this.post);
    // }
    // this.getPost(this.post);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogPost.vue